interface OnboardingProgressProps {
  progress: number; // 0-100
}

export function OnboardingProgress({ progress }: OnboardingProgressProps) {
  return (
    <div
      className="w-full h-1 bg-muted rounded-full overflow-hidden"
      data-testid="onboarding-progress-bar"
    >
      <div
        className="h-full rounded-full transition-all duration-500 ease-out"
        style={{
          width: `${progress}%`,
          background: 'linear-gradient(90deg, var(--secondary), var(--primary))',
        }}
        role="progressbar"
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      />
    </div>
  );
}
